import {
    StyledDrawer,
    StyledDrawerContentWrapper,
    StyledListItem,
    StyledListLinkWrapper,
} from "./DashboardSidebarBar.styled";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import avatarPNG from "commons/assets/avatar.png";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import {useLocation} from "react-router-dom";
import {Link} from "react-router-dom";
import {getRoleByRoleId} from "commons/constants/ditionaries";
import {useTranslation} from "react-i18next";

type RouterLink = {
    variant: 'routerLink';
    label: string;
    subLabel?: string;
    to: string;
    renderBottomLine?: boolean;
    isShowing?: boolean;
    attr?: any;
};

type PdfLink = {
    variant: 'pdfLink';
    label: string;
    subLabel?: string;
    to?: string;
    // pdfItem?: string;
    renderBottomLine?: boolean;
    isShowing?: boolean;
    attr?: any;
};

export type SidebarItem = RouterLink | PdfLink;

export interface DashboardSidebarBarProps {
    isOpen: boolean;
    onClose: () => void;
    user: {
      firstname?: string,
      lastname?: string,
      email: string,
      phone?: string,
      roles: any[],
      addresses?: any[],
    };
    sidebarItemsData: SidebarItem[];
}

const DashboardSidebarBar = ({
    isOpen,
    onClose,
    user,
    sidebarItemsData,
}: DashboardSidebarBarProps) => {
    const location = useLocation();
    const { t } = useTranslation();
    return (
        <StyledDrawer
            anchor="left"
            open={isOpen}
            onClose={onClose}
            variant="temporary"
        >
            <StyledDrawerContentWrapper>
                <Box pt={3} pl={2} pr={2} pb={2}>
                    <Avatar variant="circular" src={avatarPNG}/>
                    <Box pt={1.5}>
                        <Typography variant="overline" display="block">
                            {`${user?.firstname} ${user?.lastname} (${t(getRoleByRoleId(user?.roles?.[0]))})`}
                        </Typography>
                        <Typography variant="caption" color="textSecondary" display="block">
                            {user.email} | {user?.phone}
                        </Typography>
                        <Typography variant="caption" color="textSecondary" display="block">
                          {
                            user?.addresses?.[0]?.street && user?.addresses?.[0]?.street
                            && `${user?.addresses?.[0]?.street}, ${user?.addresses?.[0]?.number}`
                          }
                        </Typography>
                        <Typography variant="caption" color="textSecondary" display="block">
                          {
                            user?.addresses?.[0]?.postcode && user?.addresses?.[0]?.city
                            && `${user?.addresses?.[0]?.postcode}, ${user?.addresses?.[0]?.city}`
                          }
                        </Typography>
                    </Box>
                    <Box pt={3}>
                        <Divider/>
                    </Box>
                    <List>
                        {sidebarItemsData
                            .filter((menuItem) => menuItem.isShowing)
                            .map((item) => (
                                <StyledListItem key={item.label}>
                                    <StyledListLinkWrapper
                                        $isActive={
                                            item.variant === 'routerLink'
                                                ? location.pathname.includes(item.to)
                                                : undefined
                                        }
                                    >
                                        <Typography
                                            component={Link}
                                            to={item.to}
                                            variant="body1"
                                            color="textPrimary"
                                            sx={{ textDecoration: 'none', fontSize: '15px' }}
                                            {...item?.attr}
                                        >
                                            {item.label}
                                        </Typography>
                                    </StyledListLinkWrapper>
                                    {item.subLabel && (
                                        <Typography
                                            component={Link}
                                            to={item?.to || ''}
                                            variant="caption"
                                            color="textPrimary"
                                            sx={{ textDecoration: 'none', fontSize: '15px' }}
                                        >
                                            <Box fontSize=".7rem">{item.subLabel}</Box>
                                        </Typography>
                                    )}
                                    {item.renderBottomLine && (
                                        <Box pt={3}>
                                            <Divider/>
                                        </Box>
                                    )}
                                </StyledListItem>
                            ))}
                    </List>
                </Box>
            </StyledDrawerContentWrapper>
        </StyledDrawer>
    );
};

export default DashboardSidebarBar;
